import { connect } from 'react-redux';
import { fetchInitData, setListType } from 'Favourites/store/actions';

import { selectIsAppLoading } from 'Favourites/store/reducers';

const mapStateToProps = (state) => {
    return {
        isLoading: selectIsAppLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchInitData: (country, language, page) => {
            dispatch(fetchInitData(country, language, page));
        },
        setListType: (value) => {
            dispatch(setListType(value));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
